import { Checkbox } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { omit } from "lib/omit"

export function SelectAllCheckbox({ ...props }) {
    const { filteredItems, selectedItems, setSelectedItems, selectedKey } = useBoundContext()
    const filteredItemIds = getFilteredItemIds({ filteredItems, selectedKey })
    const selectedFilteredCount = filteredItemIds.filter((id) => selectedItems[id]).length
    const allSelected = filteredItemIds.length > 0 && selectedFilteredCount === filteredItemIds.length
    const someSelected = selectedFilteredCount > 0 && !allSelected

    return (
        <Checkbox
            indeterminate={someSelected}
            checked={allSelected}
            onChange={() => handleSelectAll({ allSelected, filteredItems, selectedKey, setSelectedItems })}
            data-cy="select-all-items-checkbox"
            {...props}
        />
    )
}

function handleSelectAll({ allSelected, filteredItems, selectedKey, setSelectedItems }) {
    return setSelectedItems((selectedItems) => {
        if (allSelected) {
            return removeFilteredSelections({ filteredItems, selectedItems, selectedKey })
        }

        return addFilteredSelections({ filteredItems, selectedItems, selectedKey })
    })
}

function getFilteredItemIds({ filteredItems, selectedKey }) {
    return (filteredItems ?? []).map((item) => item[selectedKey])
}

function removeFilteredSelections({ filteredItems, selectedItems, selectedKey }) {
    let remainingSelections = { ...selectedItems }

    for (const item of filteredItems ?? []) {
        remainingSelections = omit(remainingSelections, item[selectedKey])
    }

    return remainingSelections
}

function addFilteredSelections({ filteredItems, selectedItems, selectedKey }) {
    const nextSelectedItems = { ...selectedItems }

    for (const item of filteredItems ?? []) {
        nextSelectedItems[item[selectedKey]] = true
    }

    return nextSelectedItems
}
